import React from 'react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  OverlayTrigger,
  Tooltip,
  Button,
} from 'react-bootstrap';
import countries from 'country-calling-code';

const UserForm = ({
  state,
  profile,
  handleSave,
  handleValue,
  currentPlan,
  subscriptionPlan,
  onUpgradePlan,
}) => (
  <Form onSubmit={handleSave} inline>
    <div className="user-info">
      <div className="existing-info">
        <h1>{profile.name}</h1>
        <div className="user-email">{profile.email}</div>
        <p>
          Please provide your full legal name and your current address. This
          information will become part of any agreements that you are involved
          in.
        </p>
        <Row>
          <Col md={12} lg={6}>
            <OverlayTrigger
              overlay={
                <Tooltip id="tooltip-name">
                  You MUST provide your full legal name
                </Tooltip>
              }
              placement="right"
            >
              <FormGroup>
                <ControlLabel>
                  <span className="text-red">*</span>Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  required
                  value={state.fullName}
                  onChange={(e) => handleValue(e, 'fullName')}
                />
              </FormGroup>
            </OverlayTrigger>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Address:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.address}
                onChange={(e) => handleValue(e, 'address')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>Company:</ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.company}
                onChange={(e) => handleValue(e, 'company')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>State:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.state}
                onChange={(e) => handleValue(e, 'state')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>Title:</ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.title}
                onChange={(e) => handleValue(e, 'title')}
              />
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>City:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.city}
                onChange={(e) => handleValue(e, 'city')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}></Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel>
                <span className="text-red">*</span>Zip/Postal:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                className="inline"
                required
                value={state.postal}
                onChange={(e) => handleValue(e, 'postal')}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} lg={6}></Col>
          <Col md={12} lg={6}>
            <FormGroup>
              <ControlLabel className="w-110px">
                <span className="text-red">*</span>Country:{' '}
              </ControlLabel>
              <FormControl
                type="text"
                componentClass="select"
                className="inline"
                value={state.country}
                onChange={(e) => handleValue(e, 'country')}
              >
                <option disabled key={-1} value={-1}>
                  Select Country
                </option>
                {countries.map((country, i) => (
                  <option key={i} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        <Row className='flex items-end'>
          <Col md={12} lg={6}>
            <FormGroup className="subscription-plan-view">
              <ControlLabel className="attorney-label">
                <span className="text-red">*</span>Subscription Plan:{' '}
              </ControlLabel>
              <div className="subscription-plan">
                <p>{currentPlan}</p>
                <div className="upgrade-plan">
                  <Button
                    disabled={
                      subscriptionPlan.length === 0 ||
                      subscriptionPlan === 'pro-annual'
                    }
                    onClick={onUpgradePlan}
                  >
                    Change Plan
                  </Button>
                </div>
              </div>
            </FormGroup>
          </Col>
          <Col md={12} lg={6}>
            <div className="edit-info">
              <button type="submit">Save</button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </Form>
);

export default UserForm;



// WEBPACK FOOTER //
// src/components/Profile/UserForm.jsx